import React from 'react'
import { styles } from '../styles'

const RemarksPdf = ({remarks}) => {
    return (<span style={{...styles.remarksPdf, ...styles.pageMargin, marginRight: '40px', marginTop: '10px', marginBottom:'10px' }}>
        {remarks}
    </span>)
}

export default RemarksPdf